module.exports = __webpack_public_path__ + "img/wheel-arrow.c8297f95.png";